var map = {
	"./board.svg": "DjGF",
	"./boardblue.svg": "Uouv",
	"./device.svg": "uNHj",
	"./deviceblue.svg": "NNlc",
	"./home.svg": "CtIy",
	"./homeblue.svg": "LWd5",
	"./machineInterconnection.svg": "Rpcv",
	"./machineInterconnectionblue.svg": "wr/A",
	"./master_data.svg": "GgWY",
	"./master_datablue.svg": "cbjS",
	"./material.svg": "DZhr",
	"./materialblue.svg": "0pbw",
	"./mission.svg": "j9+9",
	"./missionblue.svg": "mlsN",
	"./production.svg": "2Ou6",
	"./productionblue.svg": "9zv4",
	"./quality.svg": "3pTx",
	"./qualityblue.svg": "/fP8",
	"./report.svg": "zdOJ",
	"./reportblue.svg": "lTcL",
	"./rework.svg": "S2/A",
	"./reworkblue.svg": "bc5p",
	"./stock.svg": "9ms6",
	"./stockblue.svg": "W/0z",
	"./technology.svg": "d0TK",
	"./technologyblue.svg": "7H97",
	"./tool.svg": "5i5F",
	"./toolblue.svg": "0IxY",
	"./tracking.svg": "s8lf",
	"./trackingblue.svg": "yurC",
	"./warning.svg": "xJH2",
	"./warningblue.svg": "/Tgq",
	"./全部-active.svg": "scJj",
	"./全部.svg": "9DzP",
	"./包装-active.svg": "TpwL",
	"./包装.svg": "SypR",
	"./喷漆-active.svg": "ovu4",
	"./喷漆.svg": "0Eq9",
	"./抛光-active.svg": "GL53",
	"./抛光.svg": "j/M4",
	"./激光-active.svg": "rkUb",
	"./激光.svg": "wmPv",
	"./焊接-active.svg": "8/+L",
	"./焊接.svg": "wl1v",
	"./金工-active.svg": "NsFD",
	"./金工.svg": "VmsF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TNPD";


//////////////////
// WEBPACK FOOTER
// ./src/svg ./node_modules/xml-loader ^\.\/.*\.svg$
// module id = TNPD
// module chunks = 99